import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { usePermission } from "@/hooks/usePermission";
import { roleBase } from "@/routes/role-paths";

/**
 * Route guard: renders children only if the user can view `feature`.
 * Otherwise redirects to their role dashboard. Fails OPEN while permissions
 * are still loading (so we never bounce a user mid-load).
 *
 * Usage in the route tree:
 *   { element: <RequireFeature feature="reports" />, children: [ ... ] }
 */
export default function RequireFeature({ feature }: { feature: string }) {
  const { user } = useAuth();
  const { canViewFeature } = usePermission();

  // Not loaded yet → let it render (ProtectedRoute already gated auth).
  if (!user) return <Outlet />;
  if (canViewFeature(feature)) return <Outlet />;

  return <Navigate to={`${roleBase(user.role)}/dashboard`} replace />;
}
